<template>
  <page-item :columnData="columnData" :orderType="14"></page-item>
</template>

<script>
import PageItem from './components/PageItem'
export default {
  name: 'reportLoss',
  components: {PageItem},
  data () {
    return {
      columnData: [{
        field: 'select',
        type: 'selection',
        width: '50',
        fixed: 'left'
      }, {
        field: 'operate',
        title: '操作',
        width: '120',
        fixed: 'left',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '日志',
          methodName: 'on-log',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-bg-85 btn-hover',
          title: '详情',
          methodName: 'on-detail'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'orderStatus',
        title: '单据状态',
        width: '150'
      }, {
        field: 'createTime',
        title: '编制日期',
        width: '120',
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'code',
        title: '单据编号',
        width: '180'
      }, {
        field: 'totalCost',
        title: '成本金额',
        width: '100'
      }, {
        field: 'businessName',
        title: '供应商',
        width: '180'
      }, {
        field: 'storehouseName',
        title: '仓库',
        width: '180'
      }, {
        field: 'remark',
        title: '备注',
        minWidth: '180'
      }]
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/reportLoss.vue